var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDarkModeSizer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9097 4.05865C11.3992 4.51896 11.2832 5.21793 11.0557 5.7403L11.0553 5.74123C10.7136 6.52226 10.5257 7.37847 10.5327 8.28414L10.5327 8.28628C10.5466 11.6472 13.3408 14.5155 16.7631 14.6555C17.2685 14.6766 17.7519 14.6415 18.2208 14.5576C18.5325 14.5009 18.8376 14.4909 19.1119 14.5549C19.3918 14.6202 19.6721 14.7725 19.8461 15.0573C20.0194 15.3408 20.0278 15.6584 19.9621 15.935C19.8974 16.2073 19.7549 16.4748 19.5684 16.7275C17.9402 18.9551 15.2298 20.3655 12.2051 20.2343C7.91235 20.0455 4.31954 16.612 4.02231 12.3651C3.75078 8.60066 5.98505 5.32246 9.23193 3.9532C9.75336 3.73235 10.4389 3.61596 10.9097 4.05865ZM10.0454 4.96159C9.9708 4.96864 9.8563 4.99439 9.7002 5.06058L9.69913 5.06103C6.89556 6.24334 4.98919 9.0613 5.22156 12.2792L5.22166 12.2806C5.47482 15.9023 8.55933 18.8705 12.2575 19.0331C14.8702 19.1463 17.2013 17.9292 18.5985 16.0169L18.6004 16.0144C18.6953 15.8859 18.7472 15.7858 18.7737 15.716C18.7008 15.7097 18.5902 15.7124 18.4355 15.7406L18.4336 15.741C17.879 15.8403 17.308 15.8816 16.7135 15.8568C12.6647 15.691 9.34762 12.3108 9.3304 8.29232C9.32225 7.21222 9.54685 6.18957 9.95359 5.25973C10.0121 5.12535 10.0367 5.02683 10.0454 4.96159ZM10.1297 4.96291C10.1297 4.96293 10.1292 4.96281 10.1282 4.9625L10.1297 4.96291Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkModeSizer);
export default __webpack_public_path__ + "static/media/darkModeSizer.69751691.svg";
export { ForwardRef as ReactComponent };